import React from 'react';
import {
  Paper, TextField, FormControl, InputLabel, Select, MenuItem,
  Button, InputAdornment
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface FilterToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  target: string;
  onTargetChange: (value: string) => void;
  onReset: () => void;
}

const FilterToolbar: React.FC<FilterToolbarProps> = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
  target,
  onTargetChange,
  onReset
}) => {
  const hasFilters = Boolean(search || status || target);

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        p: 1,
        mb: 1.5,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
        bgcolor: '#f8fafc',
        borderColor: '#e2e8f0',
        borderRadius: '8px'
      }}
    >
      <TextField
        size="small"
        placeholder="Поиск по тексту или автору..."
        value={search}
        onChange={e => onSearchChange(e.target.value)}
        sx={{
          flexGrow: 1,
          minWidth: 220,
          bgcolor: 'white',
          '& .MuiInputBase-input': { py: 0.6, fontSize: '0.85rem' }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
            </InputAdornment>
          )
        }}
      />

      <FormControl size="small" sx={{ minWidth: 150, bgcolor: 'white' }}>
        <InputLabel sx={{ fontSize: '0.85rem', top: -3 }}>Важность</InputLabel>
        <Select
          value={status}
          label="Важность"
          onChange={e => onStatusChange(e.target.value)}
          sx={{ fontSize: '0.85rem', '& .MuiSelect-select': { py: 0.6 } }}
        >
          <MenuItem value="" sx={{ fontSize: '0.85rem' }}>Все статусы</MenuItem>
          <MenuItem value="important" sx={{ fontSize: '0.85rem' }}>Важные</MenuItem>
          <MenuItem value="normal" sx={{ fontSize: '0.85rem' }}>Обычные</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 160, bgcolor: 'white' }}>
        <InputLabel sx={{ fontSize: '0.85rem', top: -3 }}>Получатели</InputLabel>
        <Select
          value={target}
          label="Получатели"
          onChange={e => onTargetChange(e.target.value)}
          sx={{ fontSize: '0.85rem', '& .MuiSelect-select': { py: 0.6 } }}
        >
          <MenuItem value="" sx={{ fontSize: '0.85rem' }}>Все адресаты</MenuItem>
          <MenuItem value="all" sx={{ fontSize: '0.85rem' }}>Всем</MenuItem>
          <MenuItem value="pharmacies" sx={{ fontSize: '0.85rem' }}>Выбранным аптекам</MenuItem>
          <MenuItem value="roles" sx={{ fontSize: '0.85rem' }}>По роли</MenuItem>
        </Select>
      </FormControl>

      {hasFilters && (
        <Button
          variant="text"
          size="small"
          onClick={onReset}
          sx={{ color: '#ef4444', textTransform: 'none', fontSize: '0.78rem', p: 0.5 }}
        >
          Сброс
        </Button>
      )}
    </Paper>
  );
};

export default FilterToolbar;
